import {upperCase2} from "@Common/utils/strings";

const specials = ["FedEx"];
export const formatServiceLevelName = (name) => {
    if (name == null) {
        return "Standard";
    }
    if (name == 'USPS_GROUND') {
        return "USPS Ground";
    }
    return name
        .split("_")
        .map((part) => {
            const s = specials.find((s) => s.toLowerCase() === part.toLowerCase());
            return s || upperCase2(part);
        })
        .join(" ")
    ;
};
